// ignore-string-externalization

import React from 'react';
import storage from 'local-storage-fallback';
import { useRouter } from 'next/router';
import { useCurrentUser } from '../../@mrkt/useCurrentUser';
import { pageView as gaPageView, setDimension, setUserId } from './ga';
import { createFrodorPageView } from '@spotify-internal/event-definitions/es5/events/createFrodorPageView';
import { createFrodorPageViewNonAuth } from '@spotify-internal/event-definitions/es5/events/createFrodorPageViewNonAuth';
import {
  logGabitoEvent,
  logNonAuthGabitoEvent,
  GabitoEvent,
} from '../../../features/src/gabito';

export const Track: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const router = useRouter();
  const lastPathname = React.useRef<string | null>(null);
  const pathname = router.asPath;
  const user = useCurrentUser();

  React.useEffect(() => {
    const href = process.browser ? window.location.href : pathname;
    let gabitoEvent = {} as GabitoEvent;

    if (user) {
      const partnerId = user.partnerIds?.google;
      if (partnerId) {
        setUserId(partnerId);
      }

      setDimension(1, 'external'); // TODO: check isEmployee flag after merging to mrkt-web
      setDimension(2, 'isNotFive');
      setDimension(3, user.hasAccess ? 'Yes' : 'No');

      // see if we can grab the last visited artist ID from the backdoor
      let artistId;
      if (user.username) {
        artistId = storage.getItem(
          `${user.username}:analytics:lastVisitedArtist`,
        );
        setDimension(4, artistId);
      }

      gabitoEvent = createFrodorPageView({
        url: href,
        pathname,
        title: document.title,
        partner_id: partnerId,
        is_employee: null,
        has_access: user.hasAccess,
        artist_id: artistId,
      });
    } else if (user === null) {
      gabitoEvent = createFrodorPageViewNonAuth({
        url: href,
        pathname,
        title: document.title,
      });
    }

    if (user !== undefined) {
      if (pathname !== lastPathname.current) {
        lastPathname.current = pathname;

        // fire gabito event
        if (user !== null) {
          logGabitoEvent(gabitoEvent);
        } else {
          logNonAuthGabitoEvent(gabitoEvent);
        }

        // fire ga event
        gaPageView();
      }
    }
  }, [pathname, user]);

  return <>{children}</>;
};
